/* eslint-disable import/no-cycle */
import Axios from 'axios';
import _ from 'lodash';

import { CustomException, getIdToken, isResponseValid } from '../helpers/functions';
import i18n from '../helpers/i18nMain';
import {
  UPDATE_CART,
  REMOVE_ITEM,
  CLEAR_CART,
  SET_CART_STATUS,
  SET_CART_DATA,
} from '../helpers/types';

export const addToCart = (newItem, overrideQTY) => (dispatch, getState) => {
  try {
    const state = getState();
    const { cartItems } = state.cart;
    let updatedCartItems = [];
    const existedItem = _.find(cartItems, i => i.Material === newItem.Material);

    if (existedItem) {
      updatedCartItems = cartItems.map(c => {
        const uc = c;
        if (uc.Material === newItem.Material) {
          if (overrideQTY) {
            uc.qty = newItem.qty;
          } else {
            uc.qty += newItem.qty;
          }
        }
        return uc;
      });
    } else {
      updatedCartItems = cartItems;
      updatedCartItems.push(newItem);
    }
    dispatch({
      type: UPDATE_CART,
      payload: updatedCartItems,
    });
  } catch (error) {
    console.log(error);
  }
};

export const addMultipleItemToCart = checkedItems => (dispatch, getState) => {
  try {
    const state = getState();
    const { cartItems } = state.cart;

    let updatedCartItems = cartItems;
    let existedItem;
    checkedItems.forEach(i => {
      existedItem = _.find(cartItems, itm => itm.Material === i.Material);
      if (existedItem) {
        updatedCartItems = cartItems.map(c => {
          const uc = c;

          if (uc.Material === i.Material) {
            uc.qty += i.qty;
          }
          return uc;
        });
      } else {
        updatedCartItems.push(i);
      }
    });

    dispatch({
      type: UPDATE_CART,
      payload: updatedCartItems,
    });
  } catch (error) {
    console.log(error);
  }
};

export const removeItem = m => ({ type: REMOVE_ITEM, payload: m });

export const clearCart = () => ({ type: CLEAR_CART });

export const getCartData = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth, cart } = state;
    const { client, systemIP } = auth;
    const { cartItems } = cart;
    dispatch({
      type: SET_CART_STATUS,
      payload: { isItemLoading: true },
    });
    const idToken = await getIdToken(dispatch, getState);

    const MainService = Axios.create({
      baseURL: `${systemIP}`,
    });
    const filterStr = cartItems.map(c => `Material eq '${c.Material}'`);

    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        'sap-client': client,
        $filter: filterStr.join(' or '),
      },
    };
    const response = await MainService.get('/ZAE_PB2B_SRV/ZAE_I_Material_07', config).catch(e => {
      console.log('err', e.toString());
    });
    if (isResponseValid(response)) {
      const data = response.data.d.results;
      let existedItem = false;
      const cartData = cartItems.map(c => {
        existedItem = _.find(data, d => {
          return d.Material === c.Material;
        });
        if (existedItem) {
          return {
            ...c,
            available: true,
            Price: c.Price,
            Currency: c.Currency,
            ConditionQuantity: c.ConditionQuantity,
          };
        }
        return {
          ...c,
          available: false,
        };
      });
      dispatch({
        type: SET_CART_DATA,
        payload: cartData,
      });
    } else {
      throw new CustomException(i18n.t('cartScreenTranslations:INVALID_RESPONSE'));
    }
  } catch (error) {
    console.log('error', error);
    dispatch({
      type: SET_CART_STATUS,
      payload: { isItemLoading: false },
    });
  }
};
